import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Sparkles, PenTool, Layers, Scissors, Heart } from 'lucide-react';
export function Curriculum() {
  const modules = [{
    title: 'Preparación de lámina',
    desc: 'Manicuria combinada y limpieza profunda',
    icon: <Scissors data-id="element-1" />
  }, {
    title: 'Bioseguridad',
    desc: 'Esterilización, descontaminación y cuidado',
    icon: <ShieldIcon data-id="element-2" />
  }, {
    title: 'Uso de torno/drill',
    desc: 'Manejo de brocas y fresas para acabado pro',
    icon: <PenTool data-id="element-3" />
  }, {
    title: 'Construcción',
    desc: 'Gel, polygel y acrílico desde cero',
    icon: <Layers data-id="element-4" />
  }, {
    title: 'Hard Gel & Capping',
    desc: 'Nivelación balance y refuerzo',
    icon: <Sparkles data-id="element-5" />
  }, {
    title: 'Técnicas Híbridas',
    desc: 'Jelly tips y nuevas tendencias',
    icon: <Sparkles data-id="element-6" />
  }, {
    title: 'Soft Gel y Dipping',
    desc: 'Formatos rápidos de salón',
    icon: <Layers data-id="element-7" />
  }, {
    title: 'Press On',
    desc: 'Sets reutilizables para vender',
    icon: <BookOpen data-id="element-8" />
  }, {
    title: 'Remoción Segura',
    desc: 'Química y en seco sin dañar',
    icon: <Heart data-id="element-9" />
  }, {
    title: 'Nail Art',
    desc: 'Desde cero, por niveles + Flowers 3D',
    icon: <PenTool data-id="element-10" />
  }, {
    title: 'Diseños Pedidos',
    desc: 'Baby boomer, baby color, baby glitter',
    icon: <Sparkles data-id="element-11" />
  }];
  return <section className="py-20 bg-white relative" data-id="element-12">
      <div className="max-w-6xl mx-auto px-4" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A2E] mb-4" data-id="element-15">
            ¿Qué vas a aprender?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-16">
            Vas a trabajar técnica real, no “tips sueltos”.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-17">
          {modules.map((mod, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="group p-6 rounded-xl border border-gray-100 bg-white hover:border-[#C9A96E]/50 hover:shadow-lg transition-all duration-300" data-id="element-18">
              <div className="w-12 h-12 bg-[#FFF8F0] rounded-full flex items-center justify-center text-[#9B2C5E] mb-4 group-hover:bg-[#9B2C5E] group-hover:text-white transition-colors" data-id="element-19">
                {mod.icon}
              </div>
              <h3 className="text-lg font-bold text-[#1A1A2E] mb-2" data-id="element-20">
                {mod.title}
              </h3>
              <p className="text-gray-500 text-sm" data-id="element-21">{mod.desc}</p>
            </motion.div>)}
        </div>
      </div>

      {/* Divider */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-[#C9A96E] to-transparent opacity-30 mt-20" data-id="element-22" />
    </section>;
}
// Helper icon component since Shield is already used above
function ShieldIcon(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-23">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" data-id="element-24" />
    </svg>;
}